import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';

interface ProductInstance {
  instance_valid_until;
  original_instances_amount;
  instances_assigned;
  codes_per_type;
  uploaded_codes;
  exported_tickets;
  potentially_wrong_tickets;
}

@Injectable()
export class ShopProductService {
  constructor(private http: HttpClient) {}
  query = () => this.http.get(`/rest-api/v1/admin/shop/products`);
  getProduct = productID => this.http.get(`/rest-api/v1/admin/companies/0/shop/products/${productID}`);
  photo_placeholders = () => this.http.get(`/rest-api/v1/admin/shop/products/photo_placeholders`);
  photoPlaceholdersByCompany = companyId =>
    this.http.get(`/rest-api/v1/admin/companies/${companyId}/shop/products/photo_placeholders`);
  post = payload => this.http.post(`/rest-api/v1/admin/shop/products`, payload);
  put = (productID, payload) => this.http.put(`/rest-api/v1/admin/shop/products/${productID}`, payload);
  createProducts = payload => this.http.post(`/rest-api/v1/admin/shop/products/create_products`, payload);
  getDays = productID => this.http.get(`/rest-api/v1/admin/shop/products/${productID}/days`);
  saveDays = (productID, payload) => this.http.post(`/rest-api/v1/admin/shop/products/${productID}/days`, payload);
  delete = productID => this.http.delete(`/rest-api/v1/admin/shop/products/${productID}`);
  delete_instance = instanceId => this.http.delete(`/rest-api/v1/admin/shop/products/instances/${instanceId}`);
  photo = (productID, payload) => this.http.put(`/rest-api/v1/admin/shop/products/${productID}/photo`, payload);
  instances = (productID, payload) =>
    this.http.put<ProductInstance>(`/rest-api/v1/admin/shop/products/${productID}/instances`, payload);
  putInstances = (productID, payload) =>
    this.http.put(`/rest-api/v1/admin/companies/0/shop/products/${productID}/instances`, payload);
  getInstancesInfo = productID =>
    this.http.get<ProductInstance>(`/rest-api/v1/admin/companies/0/shop/products/${productID}/instances_info`);
  getCustomerTicketUploads = productID =>
    this.http.get(`/rest-api/v1/admin/companies/0/shop/products/${productID}/customer_ticket_uploads`);
  getCustomerTicketUploadCodes = (productID, uploadId) =>
    this.http.get<{codes: string[]}>(
      `/rest-api/v1/admin/companies/0/shop/products/${productID}/customer_ticket_upload_codes`,
      {params: {upload_id: uploadId}},
    );
  publish = (productID, payload) => this.http.put(`/rest-api/v1/admin/shop/products/${productID}/publish`, payload);
  unpublish = (productID, payload) => this.http.put(`/rest-api/v1/admin/shop/products/${productID}/unpublish`, payload);
  upload_mobile_tickets = (productID, payload) =>
    this.http.post(`/rest-api/v1/admin/shop/products/${productID}/mobile_tickets`, payload);
  upload_mobile_tickets_progress = productID =>
    this.http.get(`/rest-api/v1/admin/shop/products/${productID}/mobile_tickets`);
  upload_pdf_tickets_progress = productID => this.http.get(`/rest-api/v1/admin/shop/products/${productID}/pdf_tickets`);
  target_audience = (payload, productID) =>
    this.http.put(`/rest-api/v1/admin/shop/products/${productID}/target_audience`, payload);
  getCommissions = productID => this.http.get(`/rest-api/v1/admin/products/${productID}/commissions`);
  updateCommissions = (productID, payload) =>
    this.http.put(`/rest-api/v1/admin/products/${productID}/commissions`, payload);
  exportTickets = (productID, payload?) =>
    this.http.post(`/rest-api/v1/admin/shop/products/${productID}/unassigned_tickets`, payload ? payload : {});
  exportProgress = (productID, task_id) =>
    this.http.get(`/rest-api/v1/admin/shop/products/${productID}/get_export_progress?task_id=${task_id}`);
  stats = productID => this.http.get(`/rest-api/v1/admin/shop/products/${productID}/stats`);
  getPricingRules = () => this.http.get(`/rest-api/v1/admin/shop/products/get_pricing_rules`);
}
